import { createContext } from 'react';

export type TTypeOfModalWindow = null | 'cropper';
export type TTypeOfErrorModalWindow =
	| null
	| 'imageFileSizeExceeded'
	| 'videoFileSizeExceeded'
	| 'pdfFileSizeExceeded'
	| 'fileUploadError'
	| 'fileDownloadError'
	| 'invalidFileFormat'
	| 'invalidPdfFormat';

export interface IStyleSettingsCarouselUploaderState {
	cropperSrc: string | null;
	typeOfModalWindow: TTypeOfModalWindow;
	typeOfErrorModalWindow: TTypeOfErrorModalWindow;
}

export const styleSettingsCarouselUploaderInitialState: IStyleSettingsCarouselUploaderState = {
	cropperSrc: null,
	typeOfModalWindow: null,
	typeOfErrorModalWindow: null,
};

export interface IStyleSettingsCarouselUploaderContext extends IStyleSettingsCarouselUploaderState {
	setCropperSrc(src: string | null): void;
	uploadImage(value: Blob): Promise<string | undefined>;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeTypeOfErrorModalWindow(value: TTypeOfErrorModalWindow): void;
}

export const StyleSettingsCarouselUploaderContext = createContext<IStyleSettingsCarouselUploaderContext>({
	setCropperSrc: () => undefined,
	uploadImage: async () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeTypeOfErrorModalWindow: () => undefined,
	...styleSettingsCarouselUploaderInitialState,
});
